module.exports = __webpack_public_path__ + "img/atmosphere.7932339a.png";